module.exports = __webpack_public_path__ + "img/warn_13.e007c0d0.png";